import { render } from "./SoftwaresIndex.vue?vue&type=template&id=0f1fe386"
import script from "./SoftwaresIndex.vue?vue&type=script&lang=js"
export * from "./SoftwaresIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__